import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ERPUtils from "../../../../helper/Utils";
import Utils from "../../../../helper/Utils";

const AdditonalPersonalDetails = (props) => {
  const {
    onChangeHandler,
    AddMoreHandler,
    RemoveHandler,
    NomineeDetailsHandler,
    SelectedFormState,
    interviewDetails,
    DateChangeHandler,
    selectedRoundData,
    validationErrors,
  } = props;

  return (
    <div>
      <h5>Personal Details</h5>
      <div className="appDivider" />
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-xs-12">
                  <label className="appFormLabel">PAN No</label>
                </div>
                <div className="col-md-6 col-xs-12">
                  <input
                    className="form-control z-depth-3"
                    onChange={onChangeHandler}
                    value={SelectedFormState.PanNo ||""}
                    name="PanNo"
                    type="text"
                    maxLength="15"
                    disabled={interviewDetails?.editable === false ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-xs-12">
                  <label className="appFormLabel">UAN No</label>
                </div>
                <div className="col-md-6 col-xs-12">
                  <input
                    className="form-control z-depth-3"
                    onChange={(event) => onChangeHandler(event, "personalDetails")}
                    value={SelectedFormState.UanNo||""}
                    name="UanNo"
                    type="text"
                    maxLength="15"
                    disabled={interviewDetails?.editable === false ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-xs-12">
                  <label className="appFormLabel">Two wheeler No</label>
                </div>
                <div className="col-md-6 col-xs-12">
                  <input
                    className="form-control z-depth-3"
                    onChange={(event) => onChangeHandler(event, "personalDetails")}
                    value={SelectedFormState.TwoWheelerNO||""}
                    name="TwoWheelerNO"
                    type="text"
                    maxLength="15"
                    disabled={interviewDetails?.editable === false ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-xs-12">
                  <label className="appFormLabel">Four wheeler No</label>
                </div>
                <div className="col-md-6 col-xs-12">
                  <input
                    className="form-control z-depth-3"
                    onChange={(event) => onChangeHandler(event, "personalDetails")}
                    value={SelectedFormState.FourWheelerNo||""}
                    name="FourWheelerNo"
                    type="text"
                    maxLength="15"
                    disabled={interviewDetails?.editable === false ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
          {!(selectedRoundData?.empJobDetailsDTO.isWithGratuity === true || selectedRoundData?.empJobDetailsDTO.isWithGratuity === "true") ? (
            <>
              <div className="col-md-6">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <label className="appFormLabel">LIC Gratuity No</label>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <input
                        className="form-control z-depth-3"
                        onChange={(event) => NomineeDetailsHandler(event, "empJobDetailsDTO", null)}
                        value={SelectedFormState.empJobDetailsDTO.gratuityNo||""}
                        name="gratuityNo"
                        type="text"
                        maxLength="11"
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <label className="appFormLabel">LIC Gratuity Date</label>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <DatePicker
                        selected={Utils.convertLocalDateToDateObj(SelectedFormState.empJobDetailsDTO.gratuityDate)}
                        showMonthDropdown
                        showYearDropdown
                        dateFormat="dd-MMM-yyyy"
                        className="form-control z-depth-3"
                        dropdownMode="select"
                        autoComplete="off"
                        placeholderText="DD-MMM-YYYY"
                        //maxDate={new Date()}
                        disabled={interviewDetails?.editable === false ? true : false}
                        onChange={(date) => DateChangeHandler(date, "gratuityDate", null, "empJobDetailsDTO")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
          {!(selectedRoundData?.empJobDetailsDTO.isWithPf === true || selectedRoundData?.empJobDetailsDTO.isWithPf === "true") ? (
            <>
              <div className="col-md-6">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <label className="appFormLabel">PF Account No</label>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <input
                        className="form-control z-depth-3"
                        onChange={(event) => NomineeDetailsHandler(event, "empJobDetailsDTO", null)}
                        value={SelectedFormState.empJobDetailsDTO.pfAccountNo||""}
                        name="pfAccountNo"
                        type="text"
                        maxLength="11"
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                      {validationErrors.PfNoError ? (
                        <p className="RoundValidationError">
                          <i className="fa fa-warning warningIcon" />
                          &nbsp; Please enter a valid a number
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <label className="appFormLabel">PF Date</label>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <DatePicker
                        selected={Utils.convertLocalDateToDateObj(SelectedFormState?.empJobDetailsDTO?.pfDate)}
                        showMonthDropdown
                        showYearDropdown
                        dateFormat="dd-MMM-yyyy"
                        className="form-control z-depth-3"
                        dropdownMode="select"
                        autoComplete="off"
                        placeholderText="DD-MMM-YYYY"
                        onChange={(date) => DateChangeHandler(date, "pfDate", null, "empJobDetailsDTO")}
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>

      <div className="appDivider" />
      <h5 className="mb-0">PF Nominee Details</h5>
      <div className="appDivider" />
      <div className="table table-responsive mt-2">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>
                <label>Name of the Nominee</label>
              </th>
              <th>
                <label>Address of the Nominee</label>
              </th>
              <th>
                <label>Date of birth</label>
              </th>
              <th>
                <label>Share %</label>
              </th>
              <th>
                <label>Nominee relationship with member</label>
              </th>
              <th>
                <label>Name of the guardian (If under 18 years old)</label>
              </th>
              <th>
                <label>Address of the guardian</label>
              </th>
            </tr>
          </thead>
          <tbody>
            {!(selectedRoundData?.empJobDetailsDTO.isWithGratuity === true || selectedRoundData?.empJobDetailsDTO.isWithGratuity === "true")
              ? SelectedFormState.empPfNomineesDTO.map((el, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        className="form-control z-depth-3"
                        onChange={(event) => NomineeDetailsHandler(event, "empPfNomineesDTO", index)}
                        id={index + "pfnominee"}
                        value={el.nominee||""}
                        name="nominee"
                        type="text"
                        maxLength="100"
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                    </td>
                    <td className="text-right">
                      <textarea
                        className="form-control z-depth-3 resizeTextArea"
                        onChange={(event) => NomineeDetailsHandler(event, "empPfNomineesDTO", index)}
                        id={index + "pfnomineeAddress"}
                        value={el.nomineeAddress||""}
                        name="nomineeAddress"
                        type="text"
                        maxLength="100"
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                      <span> {el.nomineeAddress?.length} /100</span>
                    </td>
                    <td>
                      <DatePicker
                        selected={Utils.convertLocalDateToDateObj(el.nomineesDob)}
                        showMonthDropdown
                        showYearDropdown
                        dateFormat="dd-MMM-yyyy"
                        className="form-control z-depth-3"
                        dropdownMode="select"
                        autoComplete="off"
                        placeholderText="DD-MM-YYYY"
                        maxDate={new Date()}
                        onChange={(date) => DateChangeHandler(date, "nomineesDob", index, "empPfNomineesDTO")}
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control z-depth-3"
                        onChange={(event) => NomineeDetailsHandler(event, "empPfNomineesDTO", index)}
                        id={index + "sharePercentage"}
                        value={el.sharePercentage||""}
                        name="sharePercentage"
                        type="number"
                        maxLength="3"
                        max={100}
                        min={0}
                        onKeyDown={ERPUtils.isValidNumber}
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control z-depth-3"
                        onChange={(event) => NomineeDetailsHandler(event, "empPfNomineesDTO", index)}
                        id={index + "pfnomineeRelationship"}
                        value={el.nomineeRelationship||""}
                        name="nomineeRelationship"
                        type="text"
                        maxLength="100"
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control z-depth-3"
                        onChange={(event) => NomineeDetailsHandler(event, "empPfNomineesDTO", index)}
                        id={index + "under18GuardName"}
                        value={el.under18GuardName||""}
                        name="under18GuardName"
                        type="text"
                        maxLength="100"
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                    </td>
                    <td className="text-right">
                      <textarea
                        className="form-control z-depth-3 resizeTextArea"
                        onChange={(event) => NomineeDetailsHandler(event, "empPfNomineesDTO", index)}
                        id={index + "under18GuardianAddress"}
                        value={el.under18GuardianAddress||""}
                        name="under18GuardianAddress"
                        type="text"
                        maxLength="100"
                        disabled={interviewDetails?.editable === false ? true : false}
                      />
                      {el.under18GuardianAddress?.length} /100
                      { interviewDetails?.editable === true ? (
                        <div className="col-md-12">
                          <button
                            type="button"
                            style={{ margin: 0 }}
                            className="RemoveLinkButton pull-right z-depthButton"
                            onClick={RemoveHandler}
                            id={index}
                            name="RemovePfNominee"
                            disabled={interviewDetails?.editable === false ? true : false}
                          >
                            <i className="fa fa-trash RemoveIcon" />
                            Remove
                          </button>
                        </div>
                      ) : null}
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
      {!(selectedRoundData?.empJobDetailsDTO.isWithPf === true || selectedRoundData?.empJobDetailsDTO.isWithPf === "true" || interviewDetails?.editable === false
        ? true
        : false) ? (
        <div className="row">
          <div className="col-md-12">
            <button type="button" className="formLinkButton pull-right z-depthButton" onClick={AddMoreHandler} name="AddPfNominee">
              <span className="fa fa-plus formAddIcon" /> Add more
            </button>
          </div>
        </div>
      ) : null}

      <div className="appDivider" />
      <h5 className="mb-0">Gratuity Nominee Details</h5>
      <div className="appDivider" />
      {!(selectedRoundData?.empJobDetailsDTO.isWithGratuity === true || selectedRoundData?.empJobDetailsDTO.isWithGratuity === "true") ? (
        <div className="table table-responsive mt-2">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>
                  <label>Name of the Nominee</label>
                </th>
                <th>
                  <label>Address of the Nominee</label>
                </th>
                <th>
                  <label>Date of birth</label>
                </th>
                <th>
                  <label>Share %</label>
                </th>
                <th>
                  <label>Nominee relationship with member</label>
                </th>
                <th>
                  <label>Name of the guardian (If under 18 years old)</label>
                </th>
                <th>
                  <label>Address of the guardian</label>
                </th>
              </tr>
            </thead>
            <tbody>
              {!(selectedRoundData?.empJobDetailsDTO.isWithGratuity === true || selectedRoundData?.empJobDetailsDTO.isWithGratuity === "true")
                ? SelectedFormState.empGratuityNomineesDTO.map((el, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          className="form-control z-depth-3"
                          onChange={(event) => NomineeDetailsHandler(event, "empGratuityNomineesDTO", index)}
                          id={index + "nominee"}
                          value={el.nominee ||""}
                          name="nominee"
                          type="text"
                          maxLength="100"
                          disabled={interviewDetails?.editable === false ? true : false}
                        />
                      </td>
                      <td className="text-right">
                        <textarea
                          className="form-control z-depth-3 resizeTextArea"
                          onChange={(event) => NomineeDetailsHandler(event, "empGratuityNomineesDTO", index)}
                          id={index + "nomineeAddress"}
                          value={el.nomineeAddress||""}
                          name="nomineeAddress"
                          type="text"
                          maxLength="100"
                          disabled={interviewDetails?.editable === false ? true : false}
                        />
                        {el.nomineeAddress?.length} /100
                      </td>
                      <td>
                        {" "}
                        <DatePicker
                          selected={Utils.convertLocalDateToDateObj(el.nomineesDob)}
                          showMonthDropdown
                          showYearDropdown
                          dateFormat="dd-MMM-yyyy"
                          className="form-control z-depth-3"
                          dropdownMode="select"
                          autoComplete="off"
                          placeholderText="DD-MMM-YYYY"
                          maxDate={new Date()}
                          onChange={(date) => DateChangeHandler(date, "nomineesDob", index, "empGratuityNomineesDTO")}
                          disabled={interviewDetails?.editable === false ? true : false}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control z-depth-3"
                          onChange={(event) => NomineeDetailsHandler(event, "empGratuityNomineesDTO", index)}
                          id={index + "sharePercentage"}
                          value={el.sharePercentage||""}
                          name="sharePercentage"
                          type="number"
                          maxLength="3"
                          max={100}
                          min={0}
                          onKeyDown={ERPUtils.isValidNumber}
                          disabled={interviewDetails?.editable === false ? true : false}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control z-depth-3"
                          onChange={(event) => NomineeDetailsHandler(event, "empGratuityNomineesDTO", index)}
                          id={index + "nomineeRelationship"}
                          value={el.nomineeRelationship||""}
                          name="nomineeRelationship"
                          type="text"
                          maxLength="100"
                          disabled={interviewDetails?.editable === false ? true : false}
                        />
                      </td>
                      <td>
                        <input
                          className="form-control z-depth-3"
                          onChange={(event) => NomineeDetailsHandler(event, "empGratuityNomineesDTO", index)}
                          id={index + "under18GuardName"}
                          value={el.under18GuardName||""}
                          name="under18GuardName"
                          type="text"
                          maxLength="100"
                          disabled={interviewDetails?.editable === false ? true : false}
                        />
                      </td>
                      <td className="text-right">
                        <textarea
                          className="form-control z-depth-3 resizeTextArea"
                          onChange={(event) => NomineeDetailsHandler(event, "empGratuityNomineesDTO", index)}
                          id={index + "under18GuardianAddress"}
                          value={el.under18GuardianAddress||""}
                          name="under18GuardianAddress"
                          type="text"
                          maxLength="100"
                          disabled={interviewDetails?.editable === false ? true : false}
                        />
                        {el.under18GuardianAddress?.length} /100
                        { interviewDetails?.editable === true ? (
                          <div className="col-md-12">
                            <button
                              type="button"
                              style={{ margin: 0 }}
                              className="RemoveLinkButton pull-right z-depthButton"
                              onClick={RemoveHandler}
                              id={index}
                              name="RemoveGrtuNominee"
                            >
                              <i className="fa fa-trash RemoveIcon" />
                              Remove
                            </button>
                          </div>
                        ) : null}
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
        </div>
      ) : null}
      {!(selectedRoundData?.empJobDetailsDTO.isWithGratuity === true ||
      selectedRoundData?.empJobDetailsDTO.isWithGratuity === "true" ||
      interviewDetails?.editable === false
        ? true
        : false) ? (
        <div className="row">
          <div className="col-md-12">
            <button type="button" className="formLinkButton pull-right z-depthButton" onClick={AddMoreHandler} name="AddGratuNominee">
              <span className="fa fa-plus formAddIcon" /> Add more
            </button>
          </div>
        </div>
      ) : null}

      <div className="formWrapper">
        <div className="row">
          <div className="col-md-3 col-xs-12 ">
            <label className="appFormLabel">Do you have Aadhar card?</label>
          </div>
          <div className="col-md-4 col-xs-12" style={{ top: "12px" }}>
            <label className="radio-inline">
              <input
                onChange={onChangeHandler}
                className="space"
                type="radio"
                name="haveAadhar"
                value="true"
                checked={SelectedFormState.haveAadhar === "true"}
                disabled={interviewDetails?.editable === false ? true : false}
              />
              Yes
            </label>
            <label className="radio-inline">
              <input
                onChange={onChangeHandler}
                className="space"
                type="radio"
                name="haveAadhar"
                value="false"
                checked={SelectedFormState.haveAadhar === "false"}
                disabled={interviewDetails?.editable === false ? true : false}
              />
              No
            </label>
          </div>
        </div>
      </div>

      {SelectedFormState.haveAadhar === "true" ? (
        <div className="formWrapper">
          <div className="row">
            <div className="col-md-3 col-xs-12">
              <label className="appFormLabel">Aadhar No</label>
            </div>
            <div className="col-md-3 col-xs-12">
              <input
                className="form-control z-depth-3"
                onChange={onChangeHandler}
                value={SelectedFormState.AadharNo || ""}
                name="AadharNo"
                type="text"
                maxLength="15"
                disabled={interviewDetails?.editable === false ? true : false}
              />
            </div>
          </div>
        </div>
      ) : null}

      {SelectedFormState.haveAadhar === "false" ? (
        <div className="formWrapper">
          <div className="row">
            <div className="col-md-3 col-xs-12">
              <label className="appFormLabel">Have you enrolled for Aadhar?</label>
            </div>
            <div className="col-md-4 col-xs-12" style={{ top: "12px" }}>
              <label className="radio-inline">
                <input
                  onChange={onChangeHandler}
                  className="space"
                  type="radio"
                  name="EnrolledForAadhar"
                  value="true"
                  checked={SelectedFormState.EnrolledForAadhar === "true"}
                  disabled={interviewDetails?.editable === false ? true : false}
                />
                Yes
              </label>
              <label className="radio-inline">
                <input
                  onChange={onChangeHandler}
                  className="space"
                  type="radio"
                  name="EnrolledForAadhar"
                  value="false"
                  checked={SelectedFormState.EnrolledForAadhar === "false"}
                  disabled={interviewDetails?.editable === false ? true : false}
                />
                No
              </label>
            </div>
          </div>
        </div>
      ) : null}

      {SelectedFormState.EnrolledForAadhar === "true" ? (
        <div className="formWrapper">
          <div className="row">
            <div className="col-md-3 col-xs-12">
              <label className="appFormLabel">Aadhar Enrollment Id</label>
            </div>
            <div className="col-md-3 col-xs-12">
              <input
                className="form-control z-depth-3"
                onChange={onChangeHandler}
                value={SelectedFormState.EnrollmentId || ""}
                name="EnrollmentId"
                type="text"
                maxLength="20"
                disabled={interviewDetails?.editable === false ? true : false}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AdditonalPersonalDetails;
